import { render } from "./BetListItem.vue?vue&type=template&id=3359edda&scoped=true"
import script from "./BetListItem.vue?vue&type=script&lang=js"
export * from "./BetListItem.vue?vue&type=script&lang=js"

import "./BetListItem.vue?vue&type=style&index=0&id=3359edda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3359edda"]])

export default __exports__